var app = angular.module("leonardo");

var ReportsOnDemandListFilters = function(
  $scope,
  $rootScope,
  $timeout,
  $controller,
  ReportService,
  OnDemandInstructionService,
  OnDemandCategoryService,
  AccountUserService,
) {

  $controller('ReportsFilters', { $scope: $scope });

  $scope.filters_valid = ReportService.filtersOnDemandInstruction;

  $scope.access_options = [
    { id: 1,
      name: 'Only users which have not accessed'
    },
    { id: 0,
      name: 'Only users which have accessed'
    }
  ];

  $scope.filters_options = [];

  $scope.initOptions = function() {
    $scope.filters_options = $scope.removeFiltersOptions('group_by').concat([
      {
        id: 'account_user',
        name: 'User(s)',
        label: 'User(s)',
        inline: false,
        type: 'options',
        multiple: true,
        modeUser: true,
        placeholder: 'All Users',
        condition: true,
        service: AccountUserService,
        conflicts: []
      },
      {
        id: 'user_role',
        name: 'User Roles',
        label: 'User Roles',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'All Roles',
        condition: true,
        options: $scope.authDataService.getRolesValid(),
        conflicts: []
      },
      {
        id: 'on_demand_category',
        name: 'On Demand Category',
        label: 'On Demand Category',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'All Categories',
        condition: true,
        service: OnDemandCategoryService,
        conflicts: ['on_demand_instruction']
      },
      {
        id: 'on_demand_instruction',
        name: 'On Demand Instruction',
        label: 'On Demand Instruction',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'All Instructions',
        condition: true,
        service: OnDemandInstructionService,
        conflicts: ['on_demand_category']
      },
      {
        id: 'not_access',
        name: 'User Access',
        label: 'User Access',
        inline: false,
        type: 'options',
        multiple: false,
        placeholder: 'Select Access',
        condition: true,
        options: $scope.access_options,
        conflicts: []
      }
    ]);
  };

  $scope.initOptions();

  $rootScope.$broadcast('filters-report:initialized');

  $timeout(function() {
    $rootScope.$broadcast('validFilters:updated', $scope.getValidFilters);
    $rootScope.$broadcast('filters-valid:updated', $scope.filters_valid);
    $rootScope.$broadcast('report-type:updated', ReportService.TYPE_ON_DEMAND_INSTRUCTION);
  }, 100);

};

app.controller('ReportsOnDemandListFilters', [
  '$scope',
  '$rootScope',
  '$timeout',
  '$controller',
  'ReportService',
  'OnDemandInstructionService',
  'OnDemandCategoryService',
  'AccountUserService',
  ReportsOnDemandListFilters
]);
